import { render, staticRenderFns } from "./DemandeRenouvellementPsychologue.vue?vue&type=template&id=57d52e09"
import script from "./DemandeRenouvellementPsychologue.vue?vue&type=script&lang=js"
export * from "./DemandeRenouvellementPsychologue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports